<template>
    <div v-loading.sync="loadingController" class="form-dzxy">
        <div class="con">
            <el-row v-if="!initialization.xt">
                <el-col :span="12" v-if="shbj==='0'">
                    <my-form
                    table
                    v-model="form"
                    label-width="150px">
                        <el-form-item
                        class="table-full-row"
                        label="甲方对接人"
                        prop="jfdjrid"
                        :rules="newRule('甲方对接人', 'required')">
                            <my-select
                            v-model="form.jfdjrid"
                            :data="initialization.zyrylist"
                            :props="{label:'TRUENAME',value:'ID'}"
                            2way="TRUENAME"
                            :TRUENAME.sync="form.jfdjr"
                            ></my-select>
                        </el-form-item>

                        <el-form-item
                        class="table-full-row"
                        label="甲方联系电话">
                            0311-66187855
                        </el-form-item>

                        <el-form-item
                        class="table-full-row"
                        label="乙方对接人"
                        prop="yfdjr"
                        :rules="newRule('甲方对接人', 'required')">
                            <el-input v-model="form.yfdjr"></el-input>
                        </el-form-item>

                        <el-form-item
                        class="table-full-row"
                        label="乙方联系电话"
                        prop="yfdjrphone"
                        :rules="newRule('乙方联系电话', 'required')">
                            <el-input v-model="form.yfdjrphone"></el-input>
                        </el-form-item>

                        <template slot="btn">
                            <el-button type="success" @click="submitHandler" style="margin-right:10px">1.生成电子协议</el-button>
                            <ca-activation 
                            type="warning" 
                            icon="el-icon-s-check" 
                            :disabled="!pdfSrc"
                            @click="stpHandler($event)">
                                2.盖章
                            </ca-activation>
                            <el-button @click="cancleHandler">关闭</el-button>

                            <el-tag type="danger">本功能需使用7.9.9及以上版本CA</el-tag>
                        </template>
                    </my-form>
                </el-col>
                <el-col :span="shbj==='0' ? 12 : 24">
                    <div class="pdf-content" :style="{height:pdfHeight}">
                        <pdf :src="pdfSrc" ref="pdf"></pdf>
                    </div>
                </el-col>
            </el-row>
            <!--邢台-->
            <div v-if="initialization.xt">
                <div class="pdf-content" :style="{height:pdfHeight}">
                    <pdf :src="pdfSrc" ref="pdf"></pdf>
                </div>
                <div class="btn-content">
                    <ca-activation 
                    type="warning" 
                    v-if="shbj==='0'"
                    icon="el-icon-s-check" 
                    :disabled="!pdfSrc"
                    @click="stpHandler($event)">
                        盖章
                    </ca-activation>
                    <el-button @click="cancleHandler">关闭</el-button>

                    <el-tag type="danger">本功能需使用7.9.9及以上版本CA</el-tag>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CaActivation from '@/components-sys/ca-activation'
import '@/js/ca/hebei/hebcaP11Object2.js'
import '@/js/ca/CAbase.js'

export default {
    mixins: [],
    components: {
        CaActivation,
    },
    props: {
        row: {
            type: Object,
            default: () => ({})
        },
        procode: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            loadingController: false,
            form:{},
            zyrylist:[],
            shbj:'0',
            pdfSrc:'',
            initialization:{},
        }
    },
    created() {
        this.formInit()
    },
    computed: {
        
        pdfHeight() {
            return `${window.innerHeight * .7}px`;
        }
    },
    methods: {
        // 取消
        cancleHandler(){
            this.$emit('cancle')
        },
        // 初始化
        formInit(){
            var that = this
            that.$get(`${that.getGetters('mngUrl')}/revision/dzxy/initdata.json`, {
                procode:that.procode
            }, (data, res) => {
                that.initialization = data
                that.form.procode= data.procode
                that.shbj = data.shbj
                if(data.shbj!=='0'||data.xt){
                    var oldSrc = that.pdfSrc;
                    that.pdfSrc =data.t_dzxy.filepath
                    
                    if(oldSrc === that.pdfSrc) {
                        setTimeout(() => {
                            that.$refs.pdf.reload();
                        }, 3000);
                    }
                }
                
            })
        },
        // 保存电子协议信息
        submitHandler() {
            var that = this
            that.$post(`${that.getGetters('mngUrl')}/revision/dzxy/dzxygenerate.json`,that.form, (data, res) => {
                that.pdfSrc = data.replace(/^http:\/\/[^/]+/, "")
            })
        },
        // 调用签章
        stpHandler(val) {
            this.loadingController = true;
            setTimeout(() => {
                this.loadingController = false;
            }, 5000);
            try {
                var that = this
                that.form.caType = val
                that.caObjectVal = that.SelectStampcallback
                //ca单位名称
                useCA(that.form.caType, 'getcadwname', that.objectVal, function (res) {
                    if (getSession('user').dwname == res.cadwname) {
                        // 选择印章
                        useCA(that.form.caType, 'pdfSelectStamp', that.caObjectVal, function (res) {})
                    }else{
                        ShowMsg('CA单位名称与当前登录单位名称不一致！', 'error');
                        return
                    }
                })
            }
            catch (e) {
                ShowMsgBox(e.message, 'SelectStamp错误');
            }
        },

        //调用SelectStamp接口，用户选择印模，返回印模相关信息:
        // boolean success: true表示操作执行成功
        // string error: 操作执行失败时的错误信息
        // string stamp: 已经选择的印模Base64字符串
        // int isSM2: 是否SM2证书，1标识SM2，0标识非SM2
        SelectStampcallback(success, error, stamp, isSM2) {
            var that = this
            //在此处添加处理代码...
            if (success) {
                var obj = {
                    isSm2Cert: isSM2,
                    stampImgB64: stamp,
                    procode: that.initialization.procode,
                    filepath: ''
                }
                if(that.initialization.xt){
                    obj.diqu = 'xingtai'
                }
                that.$post(`${that.getGetters('mngUrl')}/revision/dzxy/hashpdf.json`, obj, data => {
                    var obj = {
                        val:data,
                        fun:that.SealHashcallback
                    }
                    // 生成签章结果
                    useCA(that.form.caType, 'pdfSealHash', obj, function (res) {})
                });
                
            } else {
                that.loadingController = false
                if(!error){
                    ShowMsgBox('<h3>请确认</h3>1、CA锁是否插入<br>2、操作步骤是否正确<br>3、是否取消操作', 'warning',{
                        dangerouslyUseHTMLString: true
                    });
                }else{
                    ShowMsgBox(error, 'SelectStamp错误');
                }

            }
        },

        //调用SealHash接口，根据摘要生成签章结果:
        // boolean success: true表示操作执行成功
        // string error: 操作执行失败时的错误信息
        // string result: 签章结果的Base64字符串
        SealHashcallback(success, error, result) {
            var that = this
            //在此处添加处理代码...
            if (success) {
                that.$post(`${that.getGetters('mngUrl')}/revision/dzxy/mergepdfseal.json`, {
                    signature: result,
                    procode: that.initialization.procode
                }, data => {
                    that.loadingController = false
                    ShowMsgBox('电子协议盖章成功', 'success');
                    that.formInit()
                });
                
            } else {
                that.loadingController = false
                ShowMsgBox(error, 'SealHash错误');
            }
        },
    },
    
    mounted: function() {
        
    }
}
</script>

<style scoped lang="scss">
.pdf-content{ height:500px; position:relative; }
.btn-content{text-align:center; margin-top:10px;}
</style>
